<template>
    <!--
        The Cmd+K palette of §9.1, rendered once by `Default.vue`. The groups — instances first,
        then clients, then the sidebar's own entries — and the open flag live in
        `layouts/layout.ts` (`useSearch`), so the topbar's search button and this modal agree on
        one state. A `UModal` around a `UCommandPalette`, the same pair the Nuxt UI dashboard
        search is built from, without that family's own colour-mode group: colour mode is the
        topbar's two-state toggle and nothing else (vue-spec `theme.md`).
    -->
    <UModal
        v-model:open="searchOpen"
        :title="$t('general.search')"
        :description="$t('nav.search_hint')"
        :ui="{ content: 'sm:max-w-xl' }"
    >
        <template #content>
            <UCommandPalette
                :groups="searchGroups"
                close
                @update:model-value="onSelect"
                @update:open="searchOpen = $event"
            />
        </template>
    </UModal>
</template>

<script lang="ts" setup>
    import type { CommandPaletteItem } from '@nuxt/ui'

    import { useSearch } from '@/layouts/layout'

    const { searchOpen, searchGroups, closeSearch } = useSearch()

    /**
     * Every item carries `to`, so the row itself performs the navigation; what is left for the
     * palette is to get out of the way. A disabled row selects nothing and closes nothing.
     */
    const onSelect = (item: CommandPaletteItem): void => {
        if (item?.disabled) return

        closeSearch()
    }

    // `usingInput`: the shortcut must fire while the caret sits in a filter field, or the
    // palette is unreachable from exactly the screens where an operator is already typing.
    defineShortcuts({
        meta_k: {
            usingInput: true,
            handler:    () => { searchOpen.value = !searchOpen.value },
        },
    })
</script>
